/**
 * Self-Service Page Component
 * Page for user self-service password change and MFA management
 */

import { useState, useEffect } from 'react';
import {
  TabList,
  Tab,
  SelectTabEvent,
  SelectTabData,
} from '@fluentui/react-components';
import { PasswordChangeForm } from '../components/SelfService/PasswordChangeForm';
import { MFAMethodList } from '../components/SelfService/MFAMethodList';
import { useTabLayoutStyles } from '../components/common/hooks/useTabLayoutStyles';

const SELF_SERVICE_TAB_KEY = 'selfServiceSelectedTab';

export function SelfServicePage() {
  const layoutStyles = useTabLayoutStyles();

  // Load saved tab from localStorage on mount, default to 'password'
  const [selectedTab, setSelectedTab] = useState<string>(() => {
    const savedTab = localStorage.getItem(SELF_SERVICE_TAB_KEY);
    return savedTab || 'password';
  });

  // Save selected tab to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SELF_SERVICE_TAB_KEY, selectedTab);
  }, [selectedTab]);

  const handleTabChange = (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedTab(data.value as string);
  };

  return (
    <div className={layoutStyles.container}>
      <div className={layoutStyles.headerCard}>
        {/* Page Header */}
        <div className={layoutStyles.header}>
          <h1 className={layoutStyles.title}>Self-Service</h1>
        </div>

        {/* Tabs */}
        <div className={layoutStyles.tabsContainer}>
          <TabList
            selectedValue={selectedTab}
            onTabSelect={handleTabChange}
          >
            <Tab value="password">Password</Tab>
            <Tab value="mfa">MFA Methods</Tab>
          </TabList>
        </div>
      </div>

      {/* Content */}
      <div>
        {selectedTab === 'password' && <PasswordChangeForm />}
        {selectedTab === 'mfa' && <MFAMethodList />}
      </div>
    </div>
  );
}
